import React, { Component } from "react";
import Teams from "../../components/teams/Teams";
import FinishedDialog from "../../components/FinishedDialog";

class TeamsContainer extends Component {
  state = {
    teamsContactInfo: {},
    contactInfoLoaded: false,
    playersContactInfo: {},
    playersContactInfoLoaded: false,

    finishedDialogOpen: false,

    days: [],
    daysByKey: {},
    daysLoaded: false,
  };

  toggleFinishedDialog = () => {
    this.setState({ finishedDialogOpen: !this.state.finishedDialogOpen });
  };

  UNSAFE_componentWillMount = () => {
    if (!this.props.refereesPage && !this.props.adminsPage) {
      this.unsubscribe = window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .collection("teamsContactInfo")
        .onSnapshot((querySnapshot) => {
          var info = {};
          querySnapshot.forEach(function (doc) {
            info[doc.id] = doc.data();
          });
          this.setState({ teamsContactInfo: info, contactInfoLoaded: true });
        });

      this.unsubscribePlayersContactInfo = window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .collection("playersContactInfo")
        .onSnapshot((querySnapshot) => {
          var info = {};
          querySnapshot.forEach(function (doc) {
            info[doc.id] = doc.data();
          });
          this.setState({
            playersContactInfo: info,
            playersContactInfoLoaded: true,
          });
        });
    }

    this.unsubscribeDays = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("days")
      .onSnapshot((querySnapshot) => {
        let days = [];
        let daysObj = {};
        querySnapshot.forEach((doc) => {
          let day = doc.data();
          day["id"] = doc.id;
          days.push(day);
          daysObj[doc.id] = doc.data();
        });
        this.setState({
          days: days.sort((a, b) => a.date - b.date),
          daysByKey: daysObj,
          daysLoaded: true,
        });
      });
  };

  componentWillUnmount = () => {
    // unsubscribe
    if (!this.props.refereesPage && !this.props.adminsPage) {
      this.unsubscribe();
      this.unsubscribePlayersContactInfo();
    }
    this.unsubscribeDays();
  };

  handleToPlayersClick = (e, toPlayers) => {
    const db = window.firebase.firestore();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    tournamentRef.update({ individualPlayers: toPlayers });
  };

  handleToJudgesClick = (e, toJudges) => {
    const db = window.firebase.firestore();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    tournamentRef.update({ useJudges: toJudges });
  };

  render() {
    return this.props.divisions.length > 0 &&
      (this.props.tournamentAdmin === undefined ||
        this.props.tournamentAdmin.manageTeams) ? (
      <div>
        <FinishedDialog
          open={this.state.finishedDialogOpen}
          handleClose={this.toggleFinishedDialog}
        />
        <Teams
          tournament={this.props.tournament}
          divisions={this.props.divisions}
          divisionsObject={this.props.divisionsObject}
          teamsContactInfo={this.state.teamsContactInfo}
          contactInfoLoaded={this.state.contactInfoLoaded}
          playersContactInfo={this.state.playersContactInfo}
          playersContactInfoLoaded={this.state.playersContactInfoLoaded}
          tournamentStatus={this.props.tournamentStatus}
          toggleFinishedDialog={this.toggleFinishedDialog}
          tournamentAdmin={this.props.tournamentAdmin}
          refereesPage={this.props.refereesPage}
          adminsPage={this.props.adminsPage}
          user={this.props.user}
          handleToPlayersClick={this.handleToPlayersClick}
          handleToJudgesClick={this.handleToJudgesClick}
          days={this.state.days}
          daysByKey={this.state.daysByKey}
          daysLoaded={this.state.daysLoaded}
        />
      </div>
    ) : null;
  }
}

export default TeamsContainer;
